





















import Modal from '~/components/Modal.vue';
import {
  ref,
  defineComponent,
  useContext,
} from '@nuxtjs/composition-api';
import {
  CheckoutAddressForm,
} from '~/helpers/checkout/address';
import type { PropType } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'PickupPoints',
  components: {
    Modal,
  },
  props: {
    address: {
      type: Object as PropType<CheckoutAddressForm>,
      default: null,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    provider: {
      type: String,
      default: '',
    },
    onClose: {
      type: Function as PropType<() => void>,
      default: () => {},
    },
  },
  setup(props) {
    const pickuppointsObserver = ref<any>(null);
    const { env } = useContext();

    const sendMessage = () => {
      if (pickuppointsObserver.value) {
        pickuppointsObserver.value.contentWindow.postMessage(
          {
            type: 'onclick',
            content: {
              filter: props.provider,
              address: `${props.address.city} ${props.address.street} ${props.address.postcode}`,
              key: env.PICKUP_POINTS_MAP_KEY,
            },
          },
          env.PICKUP_POINTS_MAP_URL,
        );
      }
    };
    return {
      pickuppointsObserver,
      sendMessage,
      url: env.PICKUP_POINTS_MAP_URL,
    };
  },
});
